import React from "react";
import PropTypes from "prop-types";

const HistoryRecordButton = props => (
  <button
    type="button"
    className={"btn ic-history-record-btn " + props.className}
    onClick={props.onClick}
  >
    <i className="far fa-folder-open"></i>
  </button>
);

export default HistoryRecordButton;

HistoryRecordButton.defaultProps = {
  className: "",
  onClick: () => {}
};

HistoryRecordButton.prototype = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
